import React, { useEffect, useState } from 'react'

import { ScrollAnimation, VideoSlider } from 'shared/components'
import { getSliderItems } from './items'

import { useQuery, useWindowSize } from 'shared/hooks'

import classes from './FirstBlock.module.scss'

export const FirstBlock = (): JSX.Element => {
  const [query, setQuery] = useQuery()
  const [minHeight, setMinHeight] = useState('')
  const { isDesktop, isLargeDesktop, height } = useWindowSize()

  useEffect(() => {
    setMinHeight(!isDesktop && !isLargeDesktop ? `${height}px` : '')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height])

  return (
    <div>
      <ScrollAnimation
        animatedProp="arc"
        arcDeg={220}
        speed={0.4}
        classes={classes.wrapper}
        styles={{
          minHeight,
        }}
      >
        <VideoSlider slides={getSliderItems(query, setQuery)} />
      </ScrollAnimation>
    </div>
  )
}
